import React, { useEffect } from 'react';

const containerStyle = {
  maxWidth: '1100px',
  margin: '140px auto 40px auto',
  padding: '32px 24px',
  textAlign: 'left',
  background: '#fff',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
};

const headingStyle = {
  color: '#3d3479',
  marginBottom: '0.5em'
};

const sectionTitleStyle = {
  fontWeight: 700,
  fontSize: '1.2em',
  marginTop: '2em',
  marginBottom: '0.5em'
};

const listStyle = {
  paddingLeft: '1.5em',
  marginBottom: '1em'
};

function PrivacyPolicy() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Privacy Policy</h1>
      <div style={{ color: '#666', marginBottom: '2em' }}>Last updated: June 2024</div>

      <div>
        <div style={sectionTitleStyle}>1. Introduction</div>
        <p>
          MusicTeachers.ai ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>2. Information We Collect</div>
        <ul style={listStyle}>
          <li><strong>Personal Information:</strong> Such as your name, email address, and other contact details you provide when registering or contacting us.</li>
          <li><strong>Usage Data:</strong> Information about how you access and use the Service, including your IP address, browser type, device information, and pages visited.</li>
          <li><strong>Cookies & Tracking:</strong> We may use cookies and similar tracking technologies to enhance your experience.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>3. How We Use Your Information</div>
        <ul style={listStyle}>
          <li>To provide, operate, and maintain our Service.</li>
          <li>To improve, personalize, and expand our Service.</li>
          <li>To communicate with you, including for customer service and updates.</li>
          <li>To process your transactions and manage your account.</li>
          <li>To detect and prevent fraud and abuse.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>4. How We Share Your Information</div>
        <ul style={listStyle}>
          <li>With service providers who help us operate our Service.</li>
          <li>To comply with legal obligations or protect our rights.</li>
          <li>In connection with a merger, sale, or acquisition of all or a portion of our business.</li>
          <li>With your consent or at your direction.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>5. Data Security</div>
        <p>
          We use reasonable administrative, technical, and physical safeguards to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>6. Your Rights and Choices</div>
        <ul style={listStyle}>
          <li>You may review, update, or delete your personal information by contacting us.</li>
          <li>You may opt out of receiving marketing communications from us at any time.</li>
          <li>You may disable cookies through your browser settings, but this may affect your experience.</li>
        </ul>
      </div>

      <div>
        <div style={sectionTitleStyle}>7. Children's Privacy</div>
        <p>
          Our Service is not intended for children under 18. We do not knowingly collect personal information from children under 18. If you believe we have collected such information, please contact us.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>8. Changes to This Privacy Policy</div>
        <p>
          We may update this Privacy Policy from time to time. We will notify users of any material changes by posting the new policy on this page. Continued use of the Service after such changes constitutes acceptance of the new policy. Please review this page periodically.
        </p>
      </div>

      <div>
        <div style={sectionTitleStyle}>9. Contact Us</div>
        <p>
          If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@musicteachers.ai">info@musicteachers.ai</a>.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
